export default __webpack_public_path__ + "./images/good-1.svg";